<template>
  <b-modal
    v-model="activModel"
    title="إضافة صورة"
    centered
    footer-class="removed"
    class="edit-modal"
    id="modal"
    no-close-on-backdrop
  >
    <validation-observer ref="addSliderValidation">
      <div>
        <div>
          <div style="position: relative">
            <div style="height: 150px">
              <img
                v-if="imageSlide"
                :src="imageSlide"
                alt="slide"
                style="width: 100%; height: 150px"
              />
            </div>

            <div
              @click="$refs.imageInputSliderUploade.click()"
              style="cursor: pointer; position: absolute; top: 0px; left: 40%"
            >
              <!-- CameraIcon -->
              <feather-icon
                color="#048042af"
                icon="UploadIcon"
                size="100"
                style="z-index: 2"
              />
            </div>
          </div>
          <input
            accept="image/*"
            type="file"
            name="image-slider"
            style="display: none"
            ref="imageInputSliderUploade"
            @change="imageUploaded"
          />
        </div>
        <small class="text-danger">{{
          imageSliderSubmit == null && validateImage ? "الحقل مطلوب" : ""
        }}</small>

        <form-input
          rules="required"
          id="titleSlide"
          label="العنوان"
          v-model="titleSlide"
        />

        <b-form-group label="تفاصيل" label-for="largeInput">
          <validation-provider
            #default="{ errors }"
            name="contact_number"
            rules="required"
          >
            <b-form-textarea
              id="textarea-default"
              v-model="descriptionSlide"
              rows="3"
              :state="errors.length > 0 ? false : null"
            />
            <small class="text-danger">{{
              errors[0] ? "الحقل مطلوب" : ""
            }}</small>
          </validation-provider>
        </b-form-group>
      </div>

      <b-row class="px-1 justify-content-end">
        <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
        <b-button
          type="submit"
          variant="primary"
          @click="
            () => {
              formSubmitCreate();
            }
          "
        >
          إضافة
        </b-button>
      </b-row>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal,
  BRow,
  BButton,
  BFormInput,
  BFormGroup,
  BFormTextarea,
} from "bootstrap-vue";
import saveBtn from "@/components/loader-btn";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import FormInput from "@/components/form-input/index.vue";

export default {
  props: {
    value: Boolean,
  },
  components: {
    BModal,
    BRow,
    BButton,
    BFormInput,
    BFormGroup,
    BFormTextarea,
    saveBtn,
    ValidationProvider,
    ValidationObserver,
    FormInput,
  },
  data() {
    return {
      titleSlide: "",
      descriptionSlide: "",
      imageSlide: null,
      imageSliderSubmit: null,
      validateImage: false,
    };
  },
  computed: {
    imageSlideNgo() {
      return this.imageSlide;
    },
  },
  methods: {
    formSubmitCreate() {

      this.$refs.addSliderValidation.validate().then(async (success) => {
        if (this.imageSliderSubmit == null) {
            this.validateImage = true;
          }
        if (success) {
          if (this.imageSliderSubmit == null) {
            this.validateImage = true;
          } else {
            this.createSlider();
            this.activModel = false;
            this.unfilter();
          }
        }
      });
    },

    imageUploaded(e) {
      this.imageSlide = URL.createObjectURL(e.target.files[0]);
      this.imageSliderSubmit = e.target.files[0];
    },
    createSlider() {
      const fd = new FormData();
      fd.append("source", this.imageSliderSubmit);
      fd.append("title", this.titleSlide);
      fd.append("description", this.descriptionSlide);
      this.$store.dispatch(`manageInterfaceNgo/ngoSlider/createSlider`, {
        fd: fd,
      });
    },
    unfilter() {
      this.imageSliderSubmit = null;
      this.descriptionSlide = "";
      this.titleSlide = "";
      this.imageSlide = null;
    },
  },
  computed: {
    activModel: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
};
</script>
